module.exports = __webpack_public_path__ + "static/Title-d72e36a67759873be196bbfbf570da94.png";